import { useState } from "react";

const cellStyle = {
  padding: "12px",
  textAlign: "center",
  borderBottom: "1px solid #f0f0f0",
  whiteSpace: "normal",
  wordWrap: "break-word",
  overflowWrap: "break-word",
  overflow: "hidden",
};

export default function ExploreItemsRow({
  key_id,
  rowItem,
  onDelete,
  onItemUpdate,
  onItemDelete,
  canEdit = true,
  isWorksheet = false,
}) {
  const [editingItemId, setEditingItemId] = useState(null);
  const [editedDescription, setEditedDescription] = useState("");
  const items = Array.isArray(rowItem.items) ? rowItem.items : [];

  return (
    <tr>
      <td style={{ ...cellStyle, width: "20vw" }}>
        <div className="d-block">
          <p>{rowItem.title}</p>
          {canEdit && onDelete && (
            <button
              className="btn btn-primary"
              style={{
                backgroundColor: "#f2c4c4",
                borderColor: "#f2c4c4",
                borderRadius: "6px",
                height: "auto",
                width: "50%",
                alignItems: "center",
                marginTop: "8px",
              }}
              onClick={() => onDelete(key_id)}
            >
              REMOVE
            </button>
          )}
        </div>
      </td>
      <td style={{ ...cellStyle, width: "35vw", textAlign: "left" }}>
        {items.map((item, index) => {
          const url = isWorksheet ? item.worksheetUrl : item.url;
          const description = isWorksheet
            ? item.sheetDescription
            : item.description;
          const isEditing = editingItemId === item.id;

          return (
            <div
              key={item.id}
              style={{
                wordBreak: "break-word",
                marginBottom: "12px",
                paddingBottom: "8px",
                borderBottom: "1px solid #d8d8d8",
              }}
            >
              <div className="d-flex justify-content-between">
                <p
                  style={{
                    margin: "0 0 4px 0",
                    fontSize: "0.95rem",
                    color: "#333",
                    flex: 1,
                  }}
                >
                  {index + 1}.{" "}
                  {canEdit && isEditing ? (
                    <input
                      value={editedDescription}
                      onChange={(e) => setEditedDescription(e.target.value)}
                      style={{
                        width: "80%",
                        padding: "4px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                      }}
                    />
                  ) : (
                    description || ""
                  )}
                </p>
                {canEdit && (
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "#bff1db",
                        borderColor: "#bff1db",
                        borderRadius: "6px",
                        alignItems: "center",
                        minWidth: "40px",
                      }}
                      onClick={() => {
                        if (isEditing) {
                          onItemUpdate?.(item.id, {
                            description: editedDescription,
                          });
                          setEditingItemId(null);
                        } else {
                          setEditingItemId(item.id);
                          setEditedDescription(description || "");
                        }
                      }}
                    >
                      <i
                        className={
                          "fa-solid fa-" + (isEditing ? "check" : "pencil")
                        }
                        style={{
                          fontSize: "1rem",
                          color: "black",
                        }}
                      />
                    </button>
                    <button
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "#f2c4c4",
                        borderColor: "#f2c4c4",
                        borderRadius: "6px",
                        alignItems: "center",
                        minWidth: "40px",
                      }}
                      onClick={() => onItemDelete?.(item.id)}
                    >
                      <i
                        className={"fa-solid fa-trash"}
                        style={{
                          fontSize: "1rem",
                          color: "black",
                        }}
                      />
                    </button>
                  </div>
                )}
              </div>
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#0066cc",
                  textDecoration: "none",
                  wordBreak: "break-all",
                  fontSize: "0.75rem",
                }}
              >
                {url}
              </a>
            </div>
          );
        })}
      </td>
      {isWorksheet && (
        <td style={{ ...cellStyle, width: "35vw", textAlign: "left" }}>
          {items.map((item, index) =>
            item.solutionUrl ? (
              <div
                key={`sol-${item.id}`}
                style={{
                  wordBreak: "break-word",
                  marginBottom: "12px",
                  paddingBottom: "8px",
                  borderBottom: "1px solid #d8d8d8",
                }}
              >
                <p
                  style={{
                    margin: "0 0 4px 0",
                    fontSize: "0.95rem",
                    color: "#333",
                  }}
                >
                  {index + 1}. {item.solutionDescription || ""}
                </p>
                <a
                  href={item.solutionUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#0066cc",
                    textDecoration: "none",
                    wordBreak: "break-all",
                    fontSize: "0.75rem",
                  }}
                >
                  {item.solutionUrl}
                </a>
              </div>
            ) : (
              <div
                key={`sol-empty-${item.id}`}
                style={{
                  marginBottom: "12px",
                  paddingBottom: "8px",
                  borderBottom: "1px solid #d8d8d8",
                  color: "#999",
                  fontSize: "0.85rem",
                }}
              >
                {index + 1}. —
              </div>
            ),
          )}
        </td>
      )}
    </tr>
  );
}
